
import ChangeColorDark from './ChangeColorDark.jsx'
import ChangeColorLight from './ChangeColorLight.jsx'
import Chrome from './Chrome.jsx'
import Download from './Download.jsx'
import IP from './IP.jsx'
import Windows from './Windows.jsx'
import ColumnsMenu from './ColumnsMenu.jsx'
import Logout from './Logout.jsx'
import PSTranscriptsLogo from './PSTranscriptsLogo.jsx'

import svgsInString from './svg-in-string'

export const ChangeColorDarkIcon = ChangeColorDark;
export const ChangeColorLightIcon = ChangeColorLight;
export const ChromeIcon = Chrome;
export const DownloadIcon = Download;
export const IPIcon = IP;
export const WindowsIcon = Windows;
export const ColumnsMenuIcon = ColumnsMenu;
export const LogoutIcon = Logout;
export const PSTranscriptsLogoIcon = PSTranscriptsLogo;

export const svgInString = svgsInString

/* TODO: заменить svg иконки на jsx */
